import React from 'react'
import { Platform, View, Text } from 'react-native'
import { useAppDispatch, useAppSelector } from '../../state/hooks'
import { CardElement } from '@stripe/react-stripe-js'
import { setCheckoutState } from '../../state/Slices/checkoutSlice'
import { SquarePaymentForm } from '../Square/SquarePaymentForm.web'
import { SMALL_WIDTH } from '../../constants/GlobalStyle'

interface WebCardDetails {
	paymentProvider: string
	setIsCardValid?: (valid: boolean) => void
	title?: string
	onPress?: any
}

export const CARD_ELEMENT_OPTIONS = {
	style: {
		base: {
			color: '#32325d',
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmoothing: 'antialiased',
			fontSize: !SMALL_WIDTH ? '18px' : '15px',
			'::placeholder': {
				color: '#626970',
			},
		},
		invalid: {
			color: '#fa755a',
			iconColor: '#fa755a',
		},
	},
}

export function WebCardElement(props: WebCardDetails) {
	const { paymentProvider, setIsCardValid = null, title = '', onPress = null } = props
	const { cardErrorMessage } = useAppSelector(state => state.checkout)
	const dispatch = useAppDispatch()

	if (Platform.OS === 'web') {
		return (
			<>
				{paymentProvider === 'stripe' ? (
					<>
						<View
							style={{
								backgroundColor: '#f2f2f2',
								borderColor: '#b2b2b2',
								borderWidth: 1,
								borderRadius: 5,
								paddingVertical: 12,
								paddingHorizontal: 10,
							}}
						>
							<CardElement
								options={CARD_ELEMENT_OPTIONS}
								onChange={cardDetails => {
									if (cardDetails.error) {
										dispatch(setCheckoutState({ cardErrorMessage: cardDetails.error.message }))
									} else {
										dispatch(setCheckoutState({ cardErrorMessage: '' }))
									}
									setIsCardValid(cardDetails.complete && cardDetails.error === undefined)
								}}
							/>
						</View>
						{cardErrorMessage && (
							<Text style={{ color: 'red', marginTop: 4 }}>{cardErrorMessage}</Text>
						)}
					</>
				) : (
					<SquarePaymentForm title={title} onPress={onPress} />
				)}
			</>
		)
	}
}

export function MobileCardElement(props: any) {
	return <></>
}
